import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PhotoIcon from './PhotoIcon';
import PinIcon from './PinIcon';
import FileIcon from './FileIcon';
import UploadMenuItem from './UploadMenuItem';
import { sendLocation, uploadFile } from '../actions/conversation';
import { preventDefault } from '../utils/events';
import { hideUpload } from '../actions/app-state';

const styles = {
    overlay: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        height: '93%',
        width: '100%',
        zIndex: '2',
    },
    container: {
        position: 'absolute',
        bottom: '58px',
        left: '7px',
        borderRadius: '6px',
        boxShadow: '0 0 10px rgba(51, 51, 51, 0.3)',
        zIndex: '2',
        opacity: '100',
    },
    menu: {
        borderRadius: '6px',
        overflow: 'hidden',
    },
    fileInput: {
        display: 'none',
    },
    photoIcon: {
        margin: '5px 9px 4px -1px',
        padding: '5px 2px 2px',
    },
    fileIcon: {
        marginLeft: '-1px',
        marginRight: '9px',
        padding: '4px 2px 1px',
    },
    locationIcon: {
        marginLeft: '-1px',
        marginRight: '9px',
        padding: '5px 2px 2px',
    },
};

export class UploadMenuComponent extends Component {
    static propTypes = {
        isHidden: PropTypes.bool,
        menuItems: PropTypes.object.isRequired,
        text: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
    };

    handleOverlayClick = () => {
        const { dispatch } = this.props;
        dispatch(hideUpload());
    };

    handleSendImageClick = (e) => {
        e.preventDefault();
        this._imageInputNode.click();
    };

    handleUploadDocumentClick = (e) => {
        e.preventDefault();
        this._fileInputNode.click();
    };

    handleShareClick = () => {
        const { dispatch } = this.props;
        dispatch(hideUpload());
        dispatch(sendLocation());
    };

    handleImageChange(e) {
        e.preventDefault();
        return this._handleUploadFile(this._imageInputNode.files);
    }

    handleFileChange(e) {
        e.preventDefault();
        return this._handleUploadFile(this._fileInputNode.files);
    }

    _handleUploadFile(files) {
        const { dispatch } = this.props;

        dispatch(hideUpload());

        return Promise.all(
            Array.from(files).map((file) => {
                return dispatch(uploadFile(file));
            }),
        ).then(() => {
            if (this._formNode) {
                this._formNode.reset();
            }
        });
    }

    _renderMenuItems() {
        const { text, menuItems } = this.props;
        const imageUploadEnabled = menuItems.imageUpload;
        const fileUploadEnabled = menuItems.fileUpload;
        const shareLocationEnabled = menuItems.shareLocation;
        const items = [];

        if (imageUploadEnabled) {
            items.push(
                <UploadMenuItem
                    key="image-upload"
                    isLast={!fileUploadEnabled && !shareLocationEnabled}
                    onClick={this.handleSendImageClick}
                >
                    <div style={styles.photoIcon}>
                        <PhotoIcon />
                    </div>
                    {text.uploadPhoto}
                </UploadMenuItem>,
            );
        }

        if (fileUploadEnabled) {
            items.push(
                <UploadMenuItem
                    key="file-upload"
                    isLast={!shareLocationEnabled}
                    onClick={this.handleUploadDocumentClick}
                >
                    <div style={styles.fileIcon}>
                        <FileIcon />
                    </div>
                    {text.uploadDocument}
                </UploadMenuItem>,
            );
        }

        if (shareLocationEnabled) {
            items.push(
                <UploadMenuItem key="share-location" isLast={true} onClick={this.handleShareClick}>
                    <div style={styles.locationIcon}>
                        <PinIcon />
                    </div>
                    {text.shareLocation}
                </UploadMenuItem>,
            );
        }

        return <div style={styles.menu}>{items}</div>;
    }

    render() {
        const { isHidden } = this.props;
        const containerStyles = {
            ...styles.container,
        };

        if (isHidden) {
            containerStyles.opacity = 0;
        }

        return (
            <form ref={(c) => (this._formNode = c)} onSubmit={preventDefault} style={styles.form}>
                <div className="upload-container" style={styles.container}>
                    {this._renderMenuItems()}
                </div>
                <input
                    type="file"
                    id="file-upload"
                    accept="*/*"
                    style={styles.fileInput}
                    onChange={this.handleFileChange.bind(this)}
                    ref={(c) => (this._fileInputNode = c)}
                />
                <input
                    type="file"
                    id="img-upload"
                    accept="image/*"
                    style={styles.fileInput}
                    onChange={this.handleImageChange.bind(this)}
                    ref={(c) => (this._imageInputNode = c)}
                />
            </form>
        );
    }
}

export default connect(
    ({ config: { menuItems }, ui: { text } }) => {
        return {
            menuItems,
            text,
        };
    },
    null,
    null,
    {
        forwardRef: true,
    },
)(UploadMenuComponent);
